const SMALL = new Set([
  "a",
  "an",
  "the",
  "at",
  "its",
  "with",
  "by",
  "and",
  "or",
  "of",
  "for",
  "to",
  "in",
  "on",
  "from",
  "as",
]);

const KEEP = /^(REChecklist|DreamHome|HOA|MLS|PDF|API|DRE|VIP)$/i;

function capWord(word) {
  if (!word) return word;
  if (KEEP.test(word)) {
    if (/^rechecklist$/i.test(word)) return "REChecklist";
    if (/^dreamhome$/i.test(word)) return "DreamHome";
    return word.length <= 4 ? word.toUpperCase() : word;
  }
  if (/[a-z][A-Z]/.test(word) || /^[A-Z]{2,}$/.test(word)) return word;
  const lower = word.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export function toTitleCase(text) {
  const str = String(text ?? "");
  if (!str) return "";
  let index = 0;
  let firstWord = true;
  return str.replace(/[A-Za-z][A-Za-z']*/g, (word) => {
    const at = str.indexOf(word, index);
    index = at + word.length;
    const before = str.slice(0, at);
    const sentenceStart = firstWord || /[.!?]\s*$/.test(before);
    firstWord = false;
    const lower = word.toLowerCase();
    if (!sentenceStart && SMALL.has(lower)) return lower;
    return capWord(word);
  });
}
